import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./services/i18next";
import App from "./App.tsx";
import "./index.css";
import { AppContextProvider } from "./contexts/AppContextProvider.tsx";
import "./services/sentry";

createRoot(document.getElementById("root")!).render(
  <>
    <I18nextProvider i18n={i18n}>
      <AppContextProvider>
        <App />
      </AppContextProvider>
    </I18nextProvider>
  </>
);
